/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { axios } from '~/util/http/axioshttp';
import { queryOptions } from '@tanstack/react-query';
import type { WoundOrderViewModel } from './WoundOrderViewModel'; 

export function getWoundOrdersForOrderOptions(orderId: string, onSuccess?: (result: WoundOrderViewModel[]) => void) {
	return queryOptions({
		queryKey: ['wound-orders-for-order', orderId],
		queryFn: async () => {
			const url = '/_api/v1/homehealth/woundmanagement/queries/getwoundordersfororder/' + orderId;
			const resp = await axios.get<WoundOrderViewModel[]>(url);
			if(onSuccess) {
				onSuccess(resp.data);
			}
			return resp.data;
		},
        enabled: Boolean(orderId)
	});
}